import moment from 'moment';

export const isoDateFormat = 'Y-MM-DD';
const dayAbsoluteFormat = 'Do MMM';
const dayFullFormat = 'dddd, Do MMM';
const weekCaptionDateFormat = 'Do MMM';
const monthCaptionDateFormat = 'MMMM';
const enDash = '–';

export function formatIsoDate(m) {
  return m.format(isoDateFormat);
}

// Mutates `now` argument.
export function formatDayRelative(day, $gettext, now = moment()) {
  const dayOffset =
    moment.duration(day.diff(now.startOf('day'))).asDays();
  switch (dayOffset) {
    case -1: return $gettext('Yesterday');
    case 0: return $gettext('Today');
    case 1: return $gettext('Tomorrow');
    default: return day.format('dddd');
  }
}

export function formatDayAbsolute(day) {
  return day.format(dayAbsoluteFormat);
}

export function formatDayFull(day) {
  return day.format(dayFullFormat);
}

// Mutates `now` argument.
export function formatWeek(week, $gettext, now = moment()) {
  const dayOffset =
    moment.duration(week.diff(now.startOf('isoWeek'))).asDays();
  switch (dayOffset) {
    case -7: return $gettext('Previous week');
    case 0: return $gettext('This week');
    case 7: return $gettext('Next week');
    default: return formatWeekAbsolute(week);
  }
}

// Mutates `now` argument.
export function formatWeekSecondary(week, now = moment()) {
  const dayOffset =
    moment.duration(week.diff(now.startOf('isoWeek'))).asDays();
  if (dayOffset >= -7 && dayOffset <= 7) {
    return formatWeekAbsolute(week);
  } else {
    return "";
  }
}

export function formatDateChip(plannedFor, $gettext) {
  if (plannedFor.parentClass === 'list') {
    if (plannedFor.parentKey === "backlog") {
      return $gettext('Unplanned')
    }
    return plannedFor.parentKey;
  }
  const startMoment = moment(plannedFor.parentKey);
  const today = moment().startOf('day')
  switch (plannedFor.parentClass) {
    case 'day':
      switch (moment.duration(startMoment.diff(today)).asDays()) {
        case 0: return "Today"
        case 1: return "Tomorrow"
        case -1: return "Yesterday"
        default: return startMoment.format('Y.MM.DD')
      }
    case 'week':
      switch (moment.duration(startMoment.diff(today.startOf('week'))).asDays()) {
        case 0: return "This week"
        default: {
          const lastWeekDay = startMoment.clone().add(6, 'day');
          const endPart = startMoment.month() === lastWeekDay.month()
            ? lastWeekDay.format('DD')
            : lastWeekDay.format('MM.DD')
          return startMoment.format('Y.MM.DD') + enDash + endPart
        }
      }
    case 'month':
      return startMoment.format('Y.MM')
    default: return plannedFor.parentKey;
  }
}

export function formatWeekAbsolute(weekStartMoment) {
  const lastWeekDay = weekStartMoment.clone().add(6, 'day');
  return (weekStartMoment.format(weekCaptionDateFormat) +
    enDash +
    lastWeekDay.format(weekCaptionDateFormat));
}

// Mutates `now` argument.
export function formatMonth(date, $gettext, now = moment()) {
  return date.format(monthCaptionDateFormat);
}

export function pastOrFuture(unitStartMoment, unit, now = moment()) {
  const offset = moment.duration(
    unitStartMoment.diff(now.startOf('day')),
  ).asDays();
  let threshold = 0;
  switch (unit) {
    case 'week': threshold = -6; break;
    case 'month': threshold = -30; break;
  }

  if (offset > 0) {
    return 'future';
  } else if (offset < threshold) {
    return 'past';
  } else {
    return 'current';
  }
}

export function calcRepeatDate(item) {
  let newDate = moment(item.plannedFor.parentKey)
    .add(item.repeat.increment, item.repeat.unit)
  let now = moment()
  if (newDate.isBefore(now)) {
    now._f = newDate._f
    newDate = now
  }
  if (item.plannedFor.parentClass == "week") {
    newDate = newDate.startOf('isoWeek')
  }
  if (item.plannedFor.parentClass == "month") {
    newDate = newDate.startOf('month')
  }
  // keep original format
  return newDate.format(newDate._f)
}
